import { render } from "./presupuestos_lista.vue?vue&type=template&id=c3b71e20"
import script from "./presupuestos_lista.vue?vue&type=script&lang=js"
export * from "./presupuestos_lista.vue?vue&type=script&lang=js"

import exportComponent from "/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__